import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig} from '@angular/material';
import { ReglaspescaComponent } from '../reglaspesca/reglaspesca.component';
import { IslascoronadosComponent } from '../islascoronados/islascoronados.component';
import { OtrodestinoComponent } from '../otrodestino/otrodestino.component';




@Component({
  selector: 'app-cardtexto',
  templateUrl: './cardtexto.component.html',
  styleUrls: ['./cardtexto.component.css']
})
export class CardtextoComponent implements OnInit {
  panelOpenState = false;
  mobile: boolean;

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit() {



  }

  limitescaptura(): void {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '80%';
    this.dialog.open (ReglaspescaComponent, dialogConfig );



  }


  islascoronadosinfo(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '80%';
    this.dialog.open (IslascoronadosComponent, dialogConfig );
  }



  otrosdestinos(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '50%';
    this.dialog.open (OtrodestinoComponent, dialogConfig );
  }
}
